import React, { useState } from 'react';
import { Mail, ArrowRight } from 'lucide-react';
import { submitForm } from '../lib/formSubmissions';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');
    setMessage('');

    try {
      const result = await submitForm({
        form_type: 'newsletter',
        submitter_email: email,
        fields: { email },
      });

      if (!result.success) throw new Error(result.error);

      setStatus('success');
      setMessage('Thank you for subscribing to our newsletter!');
      setEmail('');
    } catch (error) {
      console.error('Newsletter subscription error:', error);
      setStatus('error');
      setMessage('Unable to subscribe at this time. Please try again later.');
    }
  };

  return (
    <div className="bg-primary-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="relative max-w-xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-white/10 backdrop-blur-sm mb-6 border border-white/20">
            <Mail className="h-8 w-8 text-white" />
          </div>
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Subscribe to Our Newsletter
          </h2>
          <p className="mt-4 text-lg leading-6 text-primary-100">
            Stay updated with our latest news, events, and spiritual insights. Join our growing community of believers.
          </p>
          <form onSubmit={handleSubmit} className="mt-8 sm:flex justify-center gap-3">
            <div className="min-w-0 flex-1">
              <label htmlFor="email" className="sr-only">Email address</label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="block w-full rounded-xl border-0 px-6 py-4 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-2 focus:ring-white sm:text-sm"
                placeholder="Enter your email"
                required
                disabled={status === 'loading'}
              />
            </div>
            <button
              type="submit"
              disabled={status === 'loading'}
              className="mt-4 sm:mt-0 w-full sm:w-auto rounded-xl bg-white px-6 py-4 text-sm font-semibold text-primary-700 shadow-sm hover:bg-primary-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center transition-colors"
            >
              {status === 'loading' ? (
                <div className="animate-spin rounded-full h-5 w-5 border-2 border-primary-700 border-t-transparent"></div>
              ) : (
                <>
                  Subscribe <ArrowRight className="ml-2 h-4 w-4" />
                </>
              )}
            </button>
          </form>
          {message && (
            <p className={`mt-4 text-sm ${status === 'success' ? 'text-green-200' : 'text-red-200'}`}>
              {message}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}